export default __webpack_public_path__ + "static/go-to@768-438148897b8c0b69ddc824111cce4f1b.svg";